module.exports = __webpack_public_path__ + "img/img3.c0cea609.jpg";